export default __webpack_public_path__ + "static/media/gameboy.61ac561f.jpg";